import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            关于51影院使用的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {faqItems.map((item, idx) => (
            <div key={idx} className="py-4 md:py-5">
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-lg text-foreground-400 transition-transform duration-200 ${
                      openIndex === idx ? 'ri-subtract-line text-primary-500' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === idx && (
                <div className="mt-3 text-sm text-foreground-600 leading-relaxed pr-10">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}